var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center",staticStyle:{"background-color":"transparent"}},[_c('div',{staticClass:"side-bar"},[_vm._t("default")],2),_c('div',{staticClass:"btn-show-menu",on:{"click":_vm.handleShow}},[(_vm.isHide)?_c('i',{staticClass:"fas fa-caret-right text-white"}):_c('i',{staticClass:"fas fa-caret-left text-white"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }